import { render, staticRenderFns } from "./handle-import-sign.vue?vue&type=template&id=13b2d856&"
import script from "./handle-import-sign.vue?vue&type=script&lang=js&"
export * from "./handle-import-sign.vue?vue&type=script&lang=js&"
import style0 from "./handle-import-sign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports